import { Heading, VStack, Input, Button, Box, Table, Thead, Tbody, Tr, Th, Td, Select, useToast, Checkbox, Text, useColorModeValue, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton, Collapse, HStack } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Tooltip } from "@chakra-ui/react";
import { jwtDecode } from "jwt-decode";
import { format } from 'date-fns';
import { useNavigate } from "react-router-dom";
import { FiEdit, FiCheck, FiX } from "react-icons/fi";
import { Batch } from "../Common/types";
import { useTenant } from "../Routers/TenantContextProvider";
import { utcTimeToLocalPretty } from '../../utils/dates';


interface Tenant {
  tenant_id: number;
  name: string;
  description: string;
  is_active: boolean;
}

// Define the expected structure of the token payload
interface TokenPayload {
  sub: string;       // Typically the username or user ID
  role_id: number;   // Role ID
  tenant_id: number; // Tenant ID
  exp?: number;      // Expiration timestamp (optional)
}

const BatchManagement = () => {
  const [batchs, setBatchs] = useState<Batch[]>([]);
  const [selectedTenant, setSelectedTenant] = useState<number | null>(null);
  const navigate = useNavigate();

  const toast = useToast();
  const tableHeaderbg = useColorModeValue("gray.200", "gray.700");

  const { tenant, loading, error } = useTenant();

  // Function to get tenant_id from the token
  const getTenantIdFromToken = (token: string): number | null => {
    try {
      const decoded: TokenPayload = jwtDecode<TokenPayload>(token);
      return decoded.tenant_id || null;
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  };


    // Function to get tenant_id from the token
    const getUserRoleIdFromToken = (token: string): number | null => {
      try {
        const decoded: TokenPayload = jwtDecode<TokenPayload>(token);
        return decoded.role_id || null;
      } catch (error) {
        console.error("Error decoding token:", error);
        return null;
      }
    };

  const formatDateTime = (dateString: string): string => {
    try {
      const date = new Date(dateString);
      return format(date, 'dd/MM/yyyy hh:mm a'); // Format: DD/MM/YYYY HH:MM am/pm
    } catch (error) {
      console.error('Invalid date format:', error);
      return 'Invalid date'; // Return a fallback for invalid dates
    }
  };

  const formatDate = (dateString: string): string => {
    try {
      const date = new Date(dateString);
      return format(date, 'dd/MM/yyyy'); // Format: DD/MM/YYYY
    } catch (error) {
      console.error('Invalid date format:', error);
      return 'Invalid date'; // Return a fallback for invalid dates
    }
  };

  // Set tenant ID on mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const tenantId = getTenantIdFromToken(token);
      console.log("Tenant ID:", tenantId);
      setSelectedTenant(tenantId);
    }
  }, []);

  // Fetch enrolled students when tenant ID is set
  useEffect(() => {
    if (selectedTenant) {
      fetchBatchs();
    }
  }, [selectedTenant]);

  const fetchBatchs = async () => {
    if (!selectedTenant) return;

    try {
      const tenantsapiurl = process.env.REACT_APP_TENANTS_API_URL || 'https://default-url.com';
      const response = await axios.get(`${tenantsapiurl}/${selectedTenant}/batch-details`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setBatchs(response.data);
    } catch (error) {
      console.error("Failed to load enrolled students", error);
    }
  };

  const handleReviewBatch = (batch_id: number) => {
    // Placeholder function

    const token = localStorage.getItem("token");
    if (token) {
      const role_id = getUserRoleIdFromToken(token);

        if (role_id == 1)
          {
          //  navigate(`/coaching/super/dashboard/batch-management/review-batch/${batch_id}`);

            navigate(`/platform/super/batch-management/review-batch/${batch_id}`);
          }
          else if(role_id == 2 && tenant)
          {
         //   navigate(`/coaching/admin/dashboard/batch-management/review-batch/${batch_id}`);

            navigate(`/platform/${tenant.tenant_slug}/app/batch-management/review-batch/${batch_id}`);
          }
      }
   
  };

  const handleAddNewBatch = () => {
    const token = localStorage.getItem("token");
    const batch_id=0;
    if (token) {
      const role_id = getUserRoleIdFromToken(token);
/*       if (role_id == 1)
        {
          navigate(`/coaching/super/dashboard/batch-management/review-batch/${batch_id}`);
        }
        else if(role_id == 2)
        {
          navigate(`/coaching/admin/dashboard/batch-management/review-batch/${batch_id}`);
        } */

           if (role_id == 1)
          {

            navigate(`/platform/super/batch-management/review-batch/${batch_id}`);
          }
          else if(role_id == 2 && tenant)
          {

            navigate(`/platform/${tenant.tenant_slug}/app/batch-management/review-batch/${batch_id}`);
          }
    }
  };

  return (
    <Box as="main" mx="auto" p={10} >
      <VStack>
        <Heading size={"md"}>Batch Manager</Heading>
      </VStack>
            <Box mt={4}>
                 <Text fontWeight="bold">Enrolled Students Details</Text>
        <Button mt={2} borderRadius={"sm"} fontSize="sm" fontWeight="normal" onClick={handleAddNewBatch}>
          + Batch
        </Button>
      </Box>
      <Box mt={4}>
     
        <Table mt={4} borderColor={"gray.300"} borderWidth={1} borderRadius="sm">
          <Thead fontSize="12">
            <Tr bgColor={tableHeaderbg}>
              <Th>ID</Th>
              <Th>Batch Title</Th>
              <Th>Course ID</Th>
              <Th>Course Title</Th>
              <Th>Frequency</Th>
              <Th>Start Time</Th>
              <Th>Location</Th>
              <Th>Start Date</Th>
              <Th>End Date</Th>
              <Th>Status</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody fontSize="12">
            {batchs.map((batch) => (
              <Tr key={batch.id}>
                <Td>{batch.id}</Td>
                <Td>{`${batch.title}`}</Td>
                <Td>{`${batch.course_id}`}</Td>
                <Td>{`${batch.course_title}`}</Td>
                <Td>{`${batch.frequency}`}</Td>
                <Td>{utcTimeToLocalPretty(batch.start_time)}</Td>
                <Td>{`${batch.location}`}</Td>
                <Td>{`${batch.start_date}`}</Td>
                <Td>{`${batch.end_date}`}</Td>
                <Td>{`${batch.is_active ? ("Active") : ("Inactive")}`}</Td>
   
                <Td>
                  <Tooltip label="Edit">
                    <Button size="sm" onClick={() => handleReviewBatch(batch.id)}>
                      Review Batch
                    </Button>
                  </Tooltip>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>


    </Box>
  );
};

export default BatchManagement;
